// extracted by mini-css-extract-plugin
export default {"MedicalClaimsPanelContainer":"BpVZFnXP","MedicalClaimsProviderContainer":"v7o22jht"};